<template>
    <div style="position: relative;">


        <div class="video-container-2">
            <div class="blobs">
                <img src="/Assets/mommydeals/img/blobanimation3.svg" class="bloby blob1">
                <img src="/Assets/mommydeals/img/blobanimation3.svg" class="bloby blob2">
            </div>

            <div class="video-container-2-title">
                <div class="heading">WE FIND YOU</div>
                <div class="heading heading-65" ref="dealsOn">DEALS ON DIAPERS</div>
                <div class="sub-heading">Never pay full price again. Our team of professional deal hunters find the deals for you</div>
                <div class="buttons-ctas">
                    <button class="button-cta button-cta-video" @click="openVideoModal()"><span class="play-icon"><i class="fa-sharp fa-solid fa-circle-play"></i></span>Watch Our Video</button>
                    <a :href="settings.socialLinks.whatsapp" target="_blank" @click="joinWhatsapp()">
                        <button class="button-cta"><span class="play-icon"><img src="/assets/img/logo-whatsapp.png" /></span>Join MommyDeals</button>
                    </a>
                </div>
            </div>
            <div class="video-container-2-phone">
                <div class="video-container-2-chat">
                    <div class="video-container-2-chat-item" v-show="showMessage">
                        <span ref="iGet">{{messageCurrent}}</span>
                        <div class="video-container-2-chat-item-bubble-thingy"></div>
                    </div>

                </div>
                <div class="video-container-2-phone-img">
                    <img src="/Assets/mommydeals/img/hand2.png" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import settings from '@/settings'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'
    import EventBus from '@/helpers/event-bus'

    export default {
        data() {
            return {
                videoId: 'gSM0FGKIDSY',
                weFindYouIndex: 5000,
                weFindYou: [
                    'DEALS ON DIAPERS',
                    'AMAZON PROMO CODES',
                    'DEALS ON KIDS PRODUCTS',
                    'DEALS ON ESSENTIALS',
                    'DEALS ON CLOTHING',
                    'PRICE DROPS',                    
                    'DEALS ON BABY PRODUCTS',
                    'DEALS ON ELECTRONICS',
                    'DEALS ON PET PRODUCTS'
                ],
                showMessage: false,
                messageCurrent: null,
                messageIndex: 5000,
                messages: [
                    'I get the best discounts ever!',
                    'I love MommyDeals - they have awesome super relevant deals!',
                    'I get the best deals of the day - every day!',
                    "It's so easy to use!",
                    "They finds me the best deals on Amazon!"
                ]
            }
        },
        created() {
            
        },
        mounted() {
            this.startAnimation1();
            this.startAnimation2();
        },
        computed: {
            settings: function () { return settings; }
        },
        methods: {
            startAnimation1() {
                this.$refs.dealsOn.innerHTML = '';

                if (this.weFindYouIndex >= this.weFindYou.length - 1)
                    this.weFindYouIndex = 0
                else
                    this.weFindYouIndex++;
                
                let txt = this.weFindYou[this.weFindYouIndex];     

                let speed = 50;
                let i = 0;
                this.typeWriter(i, txt, speed, this.$refs.dealsOn)

                setTimeout(this.startAnimation1, 4000);
            },
            startAnimation2() {
               
                if (this.messageIndex >= this.messages.length - 1)
                    this.messageIndex = 0
                else
                    this.messageIndex++;


                this.messageCurrent = this.messages[this.messageIndex];
                this.showMessage = true;

                setTimeout(() => {
                    this.showMessage = false;

                    setTimeout(this.startAnimation2, 1000);                    

                }, 5200);


            },
            typeWriter(i, txt, speed, el) {
                if (i < txt.length) {
                    el.innerHTML += txt.charAt(i);
                    
                    setTimeout(() => {
                        this.typeWriter(i + 1, txt, speed, el);
                    }, speed);
                }
                else {
                    return;
                }
            },
            openVideoModal() {
                EventBus.$emit('playHomepageVideo');
            },
            joinWhatsapp() {
                ga.event('click', { 'event_category': 'whatsapp', 'event_label': 'whatsapp', 'transport_type': 'beacon' });
                clicky.goal("JoinWhatsAppHomepageBanner2")
            }
        }
    }
</script>

<style>

    .video-container-2-title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-family: 'Quicksand';
        line-height: 39px;
        letter-spacing: 0px;
        font-weight: 700;
        color: black;
        font-size: 39px;
        text-align: left;
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: 4;
    }
    
    .sub-heading {
        line-height: 33px;
        letter-spacing: 0px;
        font-weight: 400;
        font-size: 22px;
        margin-top: 30px;
        margin-bottom: 30px;
        width: 360px;
    }

    .video-container-2 {
        display: grid;
        grid-template-columns: 2fr 3fr;
        grid-template-rows: 1fr 1fr 1fr;
        width: 90%;
        max-width: 1260px;
        margin-left: auto;
        margin-right: auto;
        /*height: 500px;*/
    }


    .video-container-2-video-play {
        grid-column-start: 1;
        grid-column-end: 1;
        grid-row-start: 2;
        grid-row-end: 2;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .video-container-2-cta {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 1260px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 15px;
    }

    .video-container-2-phone {
        grid-column-start: 2;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: 4;
        
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr;
    }

    .video-container-2-chat {
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: 3;
        display: flex;
        align-items: flex-end;
        justify-content: center;
    }

    .video-container-2-phone-img {
        overflow: hidden;
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        grid-column-start: 2;
        grid-column-end: 2;
        grid-row-start: 2;
        grid-row-end: 4;

        animation-name: spin;
        animation-duration: 8000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    .video-container-2-chat-item {
        border: 2px solid #000;
        padding: 30px;
        width: 100%;
        max-width: 400px;

        background-color: #DCF8C6;
        position: relative;

        animation-duration: 2s;
        animation-name: bounce;
        animation-timing-function: cubic-bezier(0.280, 0.840, 0.420, 1);
    }

    .video-container-2-phone .video-container-2-phone-img img {
        max-height: 100%;
        max-width: 100%;
    }

    .video-container-2-chat-item-bubble-thingy {
        border: 2px solid #000;
        border-left: 0;
        border-bottom: 0;
        background-color: #DCF8C6;
        height: 10px;
        width: 10px;
        margin: 0;
        padding: 0;
        position: absolute;
        right: -7px;
        bottom: 15px;
        transform: rotateZ(45deg);
    }

    .heading-65 {
        height: 65px;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        25% {
            transform: rotate(-12deg);
        }

        50% {
            transform: rotate(0deg);
        }

        75% {
            transform: rotate(-12deg);
        }

        100% {
            transform: rotate(0deg);
        }
    }

    @keyframes bounce {
        0% {
            transform: matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        4.7% {
            transform: matrix3d(0.45, 0, 0, 0, 0, 0.45, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        9.41% {
            transform: matrix3d(0.883, 0, 0, 0, 0, 0.883, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        14.11% {
            transform: matrix3d(1.141, 0, 0, 0, 0, 1.141, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        18.72% {
            transform: matrix3d(1.212, 0, 0, 0, 0, 1.212, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        24.32% {
            transform: matrix3d(1.151, 0, 0, 0, 0, 1.151, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        29.93% {
            transform: matrix3d(1.048, 0, 0, 0, 0, 1.048, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        35.54% {
            transform: matrix3d(0.979, 0, 0, 0, 0, 0.979, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        41.04% {
            transform: matrix3d(0.961, 0, 0, 0, 0, 0.961, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        52.15% {
            transform: matrix3d(0.991, 0, 0, 0, 0, 0.991, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        63.26% {
            transform: matrix3d(1.007, 0, 0, 0, 0, 1.007, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        85.49% {
            transform: matrix3d(0.999, 0, 0, 0, 0, 0.999, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        100% {
            transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
    }

    .blobs {
        position: absolute;
        height: 1000px;
        width: 100%;
        left: 0px;
        z-index: -1;
        overflow: hidden;
    }

        .blobs .blob1 {
            height: 871px;
            top: 145px;
            position: absolute;
            left: -25%;
        }

        .blobs .blob2 {
            height: 871px;
            top: -417px;
            position: absolute;
            right: -25%;
        }

    span.play-icon {
        display: flex;
    }

    .button-cta-video {
        margin-bottom: 10px;
    }

    .buttons-ctas{
        margin-bottom: 15px;
    }

    button.button-cta.button-cta-video {
        background-color: #e91e63;
    }

    @media all and (min-width: 1921px){
        img.bloby.blob1 {
            left: -10%;
        }

        img.bloby.blob2 {
            right: -10%;
        }
    }

    @media all and (max-width: 768px) {
        .video-container-2 {
            grid-template-columns: 1fr;
            grid-template-rows: 1fr;
        }

        .video-container-2-title {
            grid-column-start: 1;
            grid-column-end: 2;
            grid-row-start: 3;
            grid-row-end: 4;
        }

        .video-container-2-phone {
            grid-column-start: 1;
            grid-column-end: 2;
            grid-row-start: 1;
            grid-row-end: 2;
        }

        /*.video-container-2 {
            height: 585px;
        }*/

        .blobs .blob1 {
            top: 230px;
            left: -50%;
        }

        .blobs .blob2 {
            display: none;
        }

        .video-container-2-phone-img {
            justify-content: flex-end;
        }

        .video-container-2-chat-item {
            padding: 15px;
        }

        .video-container-2-cta {
            margin-top: 10px;
            justify-content: flex-start;
            width: 90%;
        }

        

    }
</style>